export enum TriggerTypes {
  OnHover = 'hover',
  OnClick = 'click',
  OnFocus = 'focus',
}
